import { Box, Text, Layer } from "grommet";
import React from 'react'
import modNumeration from '../functions/modNumeration';
import TocList from "./TocList";
import {BookInfo} from '../config/types';

const NumeroUnit = (props:any) => {
    const [aBook, setABook] = React.useState<BookInfo|null>(null)
    const [Tocs, setTocs] = React.useState([])
    React.useEffect(() => {
        let bookInfo = props.bookinfo
        let tocInfo = props.tocinfo
        setABook(bookInfo)
        setTocs(tocInfo)
        console.log("NumeroUnit", bookInfo, tocInfo);
    },[])



  const BookInfoPanel = (props: any) => (
    <Box width="100%"
      direction="column"
    >
      <Box direction="row" align="center" justify="center" margin={{bottom:"10px"}}>
        <Text size="15px" >{props.booktitle}</Text>
        <Text size="17px" weight="bold"
          margin={{left:"20px"}}
        > {modNumeration(props.numeration)}</Text>
      </Box>
      <Box direction="column" align="center" justify="start">
        <Text size="12px" margin={{ left: "10px", bottom: "2px" }}> 출간 : {props.publishdate}</Text>
        <Text size="12px" margin={{ left: "10px", bottom: "2px" }}> 출판 : {props.publisher}</Text>
      </Box>
    </Box>
  )

  return (
    <>
      <Box width="full" height="100%"  direction="column"
        align="center" justify="start">
        {aBook&& <BookInfoPanel
          booktitle={aBook.book_title}
          numeration={aBook.numeration}
          publishdate={aBook.publish_date}
          publisher={aBook.publisher}
        />}
        {Tocs.length===0?
          <Box align="center" justify="center" height="100%"
            margin={{ top: "20px", left: "10px" }}>
            <Text size="15px" weight="bold">목차정보 없음</Text>
          </Box>
          :
          <Box justify='start' height='full' width='full'>
            <TocList tocinfo={Tocs} bookinfo={aBook}/>
            </Box>
        }
      </Box>
    </>
  )
}

export default NumeroUnit;